"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _reactColor = require("react-color");

var _ = require("..");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var PickerDropdown = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(PickerDropdown, _React$Component);

  var _super = _createSuper(PickerDropdown);

  function PickerDropdown() {
    var _this;

    (0, _classCallCheck2["default"])(this, PickerDropdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      color: _this.props.selected
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChangeComplete", function (colorSelected) {
      _this.setState({
        color: colorSelected
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onSave", function (e, color) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          onChangeCustomColor = _this$props.onChangeCustomColor,
          closeTrigger = _this$props.closeTrigger;
      e.preventDefault();
      onChangeCustomColor(color);
      closeTrigger();
      onChange(color.toUpperCase());
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onCancel", function (e) {
      var closeTrigger = _this.props.closeTrigger;
      e.preventDefault();
      closeTrigger();
    });
    return _this;
  }

  (0, _createClass2["default"])(PickerDropdown, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          saveLabel = _this$props2.saveLabel,
          cancelLabel = _this$props2.cancelLabel;
      var color = this.state.color;
      var _onChangeComplete = this.onChangeComplete,
          onSave = this.onSave,
          onCancel = this.onCancel;
      return /*#__PURE__*/React.createElement(_.Dropdown, {
        className: "pp-color-picker-select ignore-react-onclickoutside"
      }, /*#__PURE__*/React.createElement(_reactColor.SketchPicker, {
        color: color,
        disableAlpha: true,
        presetColors: [],
        onChangeComplete: function onChangeComplete(colorSelected) {
          return _onChangeComplete(colorSelected.hex.toUpperCase());
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: "pp-color-picker-select-footer pp-display-flex pp-flex-justify-end"
      }, /*#__PURE__*/React.createElement(_.Button, {
        onMouseDown: function onMouseDown(e) {
          return onCancel(e);
        },
        theme: "dark",
        size: "sm"
      }, cancelLabel), /*#__PURE__*/React.createElement(_.Button, {
        onMouseDown: function onMouseDown(e) {
          return onSave(e, color);
        },
        size: "sm"
      }, saveLabel)));
    }
  }]);
  return PickerDropdown;
}(React.Component);

PickerDropdown.defaultProps = {
  cancelLabel: 'Cancel',
  closeTrigger: function closeTrigger() {},
  onChangeCustomColor: function onChangeCustomColor() {},
  saveLabel: 'Save'
};
var _default = PickerDropdown;
exports["default"] = _default;